// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Sw67","actions":"GroupTable_actions__2pP47","deleteModalFooter":"GroupTable_deleteModalFooter__1186a"};